import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "next" }
const _hoisted_2 = { style: {"font-size":"1.9vh"} }
const _hoisted_3 = { class: "btns" }
const _hoisted_4 = { class: "contentSetting" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "content add" }
const _hoisted_7 = { class: "contentSetting_right" }
const _hoisted_8 = { class: "gaodeMap" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 1,
  class: "map2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_EditPen = _resolveComponent("EditPen")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_DeleteFilled = _resolveComponent("DeleteFilled")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_MapContainer = _resolveComponent("MapContainer")!
  const _component_Cavan = _resolveComponent("Cavan")!
  const _component_el_row = _resolveComponent("el-row")!
  const _directive_draggable = _resolveDirective("draggable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t("Content.contentEdit")), 1),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          style: {"background":"#4f4f4f","color":"#fff"},
          size: "large",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.value == '自定义地图' ? _ctx.saveContent() : _ctx.saveContent2()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("Content.save")), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "zhanwei3" }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "zhanwei3" }, null, -1)),
    _createVNode(_component_el_select, {
      modelValue: _ctx.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.value) = $event)),
      placeholder: "Select",
      size: "large",
      style: {"width":"240px","margin-left":"10px","margin-top":"20px"}
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
          return (_openBlock(), _createBlock(_component_el_option, {
            key: item.value,
            label: item.label,
            value: item.value
          }, null, 8, ["label", "value"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 12
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    size: "large",
                    color: "#000",
                    onClick: _ctx.addLevel
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("Content.addLevel")), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _withDirectives((_openBlock(), _createElementBlock("div", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list2, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "content",
                      key: item.id
                    }, [
                      _createTextVNode(_toDisplayString(item.id) + ". " + _toDisplayString(item.name) + " ", 1),
                      _createVNode(_component_el_icon, {
                        size: "24",
                        class: "edit",
                        onClick: ($event: any) => (_ctx.toEditLevel(item.levelId))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_EditPen)
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_el_icon, {
                        size: "24",
                        class: "delete",
                        onClick: ($event: any) => (_ctx.deleteLevel(item.levelId))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DeleteFilled)
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]))
                  }), 128))
                ])), [
                  [_directive_draggable, [
              _ctx.list2,
              {
                animation: 150,
                onUpdate: _ctx.onUpdate,
                onStart: _ctx.onStart,
              },
            ]]
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 12
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  (_ctx.value == '高德地图')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createVNode(_component_MapContainer, {
                          onChangePos: _ctx.changePos,
                          long: _ctx.long,
                          lat: _ctx.lat
                        }, null, 8, ["onChangePos", "long", "lat"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.value == '自定义地图')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createVNode(_component_Cavan, {
                          ref: "Cav",
                          imgUrl: _ctx.CavImg
                        }, null, 8, ["imgUrl"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ], 64))
}